/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Email_ExistsInputs */



/**
* | output |
* | --- |
* | "An account with this email already exists." |
*
* @param {Login_Error_Email_ExistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_email_exists = /** @type {((inputs?: Login_Error_Email_ExistsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Email_ExistsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un compte avec cet email existe déjà.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für diese E-Mail-Adresse existiert bereits ein Konto.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esiste già un account con questo indirizzo email.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Учетная запись с этим адресом электронной почты уже существует.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ya existe una cuenta con este correo electrónico.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此邮箱地址已存在账户。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このメールアドレスのアカウントは既に存在します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस ईमेल पते से पहले से ही एक खाता मौजूद है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Já existe uma conta com este endereço de e-mail.")
	return /** @type {LocalizedString} */ ("An account with this email already exists.")
});